import React from "react";
import {Navigate, useLocation} from "react-router-dom";
import {useAuth} from "./AuthProvider";


const RedirectAuth = ({children}) => {
    const auth = useAuth();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/";

    if (auth.isAuthenticated) {
        // Send them back to the page they tried to visit when they were
        // redirected to the login page. Use { replace: true } so we don't create
        // another entry in the history stack for the login page.  This means that
        // when they get to the protected page and click the back button, they
        // won't end up back on the login page, which is also really nice for the
        // user experience.
        return <Navigate to={from} replace={true}/>
    }
    else{
        return children
    }
}

export default RedirectAuth;